import {InjectionToken} from '@angular/core';

export const ECC_SERVER_URL = new InjectionToken<string>('ECC_SERVER_URL');
export const ECC_BASE_URL = new InjectionToken<string>('ECC_BASE_URL');
export const ECC_SERVICE_ENDPOINT_REAL = new InjectionToken<string>('ECC_SERVICE_ENDPOINT_REAL');
export const ECC_SERVICE_ENDPOINT_TEST = new InjectionToken<string>('ECC_SERVICE_ENDPOINT_TEST');
export const ECC_SERVICE_ENDPOINT_REAL_URL = new InjectionToken<string>('ECC_SERVICE_ENDPOINT_REAL_URL');
export const ECC_SERVICE_ENDPOINT_TEST_URL = new InjectionToken<string>('ECC_SERVICE_ENDPOINT_TEST_URL');

export const DATEFORMAT_CULTURE = new InjectionToken<string>('DATEFORMAT_CULTURE');
